import { teamService } from '@/services';
import { useTeamStore } from '@/stores/team';

export function useTeamFavorite() {
    function isTeamProcessing(teamId: number): boolean {
        const store = useTeamStore();
        return teamId in store.favoriteTeamProcessing;
    }

    function isTeamFavorite(teamId: number): boolean {
        const store = useTeamStore();
        return teamId in store.favoriteTeam;
    }

    function toggleTeamFavorite(teamId: number): void {
        if (isTeamProcessing(teamId)) {
            return;
        }

        if (isTeamFavorite(teamId)) {
            void teamService.removeFavorite(teamId);
        } else {
            void teamService.addFavorite(teamId);
        }
    }

    return {
        isTeamProcessing,
        isTeamFavorite,
        toggleTeamFavorite,
    };
}
